<template>
  <div>
    <section-collapseable
      title="Contact Types"
      editable
      @edit="$refs.editContactTypes.open({id: contact.id})"
    >
      <p :class="{'no_types': !contactTypes.length}">{{ contactTypeList }}</p>

      <hr class="type_tag_line">

      <div class="section_title flex flex-vertical-center">
        <div class="section_title--header">
          <h2 class="text-uppercase">Attach Tags</h2>
        </div>
      </div>
      <form-field-collection
        v-model="contactTags"
        :options="availableTags"
        field="label"
        placeholder="Select tag"
        icon="label"
        :validation-errors="validationErrors.tags"
        :loading="isSaving"
        :disabled="isSaving"
        @change="attachTags"
      ></form-field-collection>
      <p class="tag_note">Note: Tags must be created via Contact Settings before attaching to a contact</p>
    </section-collapseable>

    <modal-container>
      <modal-crud-form
        ref="editContactTypes"
        title="Contact Types"
        form-component="contact-contact-type-form"
        hide-delete-button
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
export default {
  name: "ContactTypesTags",
  data() {
    return {
      isSaving: false,
      form: {
        id: '',
        tags: []
      },
      validationErrors: {},
    }
  },
  created() {
    this.form.id = this.contact.id
  },
  computed: {
    contact() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.contact : {
        id: null,
      };
    },
    contactTags: {
      get() {
        if (!this.$store.state.activeContact) return [];

        return this.$store.state.activeContact.tags
      },
      set(value) {
        this.$store.commit('setActiveContactProp', ['tags', value])
      }
    },
    availableTags() {
      return this.$store.getters.contactTags;
    },
    availableContactTypes() {
      return this.$store.getters.contactTypes;
    },
    contactTypes() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.contactContactTypes : [];
    },
    contactTypeList() {
      if (this.contactTypes.length) {
        let typeString = '';

        this.contactTypes.forEach(type => {
          const contactType = this.availableContactTypes.find(contactType => contactType.id === type.contact_type_id);

          typeString += contactType.name + ', ';
        })

        return typeString.trim().slice(0, -1);
      } else {
        return 'no contact types'
      }
    }
  },
  methods: {
    attachTags() {
      this.form.tags = this.contactTags
      this.isSaving = true
      this.$api.contacts.attachTags(this.form)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Tags was updated',
            type: 'is-success'
          })
          this.$store.commit('events/toggleEvent', 'reloadContactTable')
        })
        .finally(() => this.isSaving = false );
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.section_title {
  margin-bottom: 0.5rem;
  size: $size-5;

  &--edit {
    margin-left: 8px;
    color: $link;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }
}

.no_types {
  font-style: italic;
}

.type_tag_line {
  margin: 0.75rem 0;
}

.tag_note {
  font-size: 0.875rem;
  color: $text-light;
  line-height: 1.2;
}
</style>
